<div #autocomplete (document:click)="onDocumentClick($event, autocomplete)" class="autocomplete">
    <div class="autocomplete-input-wrapper">
        <input #searchInput type="text" class="twc-input" [value]="searchText" [placeholder]="placeholder"
            (cwDebounceKeyUp)="filterOptions(searchInput.value)" [cwDebounceKeyUpTime]="500">
        <twc-loader *ngIf="loading" size="tiny"></twc-loader>
    </div>

    <div class="autocomplete-menu" [ngClass]="menuClassStyles"
        *ngIf="searchText.length >= minValueLength && optionList?.length">
        <div *ngIf="!loading" class="autocomplete-menu-content">
            <twc-list>
                <twc-list-item *ngFor="let option of optionList" (click)="onUpdateSelectedOption(option)">
                    <div class="twc-body twc-list-item-col-1">{{option.value}}</div>
                </twc-list-item>
            </twc-list>
            <twc-paginator [hidden]="totalResults < maxItemPerPage || filterType !== filterTypeEnum.CUSTOM"
                cwHidePaginatorControl [length]="totalResults" [pageSize]="pageSize" [current]="currentPage"
                (currentChange)="changePage($event)"></twc-paginator>
        </div>
    </div>
    <div class="info-block twc-mt-2 twc-ml-1" *ngIf="!hiddenOptionInfo">
        <small *ngIf="notFound" class="twc-form-helper">
            <twc-icon shape="close"></twc-icon>
            {{'GENERAL.NOT_RESULTS_FOUND' | translate}}
        </small>
        <small *ngIf="found" class="twc-form-helper">{{selectedOptionInfo}}
        </small>
    </div>
</div>